import { InputHTMLAttributes } from 'react'
import {
  CommonStyledInput,
  StyledInputLabelWrapper,
  StyledLabel,
} from './styles'

export interface InputControlProps
  extends InputHTMLAttributes<HTMLInputElement> {
  showLabel?: boolean
}

function InputControl(props: InputControlProps) {
  return (
    <>
      {props.showLabel && (
        <StyledInputLabelWrapper>
          <StyledLabel htmlFor={props.name}>{props.placeholder}</StyledLabel>
        </StyledInputLabelWrapper>
      )}
      <CommonStyledInput {...props} />
    </>
  )
}

export default InputControl
